<template>
  <div class="exr-item exr-item-words">
    <WordSelect v-model="value.word_id" :on-select="handleSelect"></WordSelect>
    <PinyinInput v-if="showPinyin" v-model="value.pinyin" :text="value.text" placeholder="拼音" :readonly="true"></PinyinInput>
    <div v-if="showAudio" class="exr-item-wrap-file"><audio :src="getFileUrl(value.audio)" controls></audio></div>
  </div>
</template>

<script>
import WordSelect from "@/components/word/WordSelect.vue";
import PinyinInput from "@/components/PinyinInput.vue";
import utils from "@/js/utils.js";

export default {
  name: "PdtItemWords",
  props: {
    value: Object,
    rightValue: Object,
    showPinyin: Boolean,
    showAudio: Boolean
  },
  components: {PinyinInput, WordSelect},
  methods: {
    getFileUrl(file) {
      return utils.url(file)
    },
    handleSelect(word) {
      this.value.pinyin = word.pinyin;
      this.value.audio = word.audio;
      this.value.image = word.image;
      this.value.text = word.text;
      this.value.translation = word.translation ? word.translation.text : '';
      let parent = this.$parent;
      while (parent && parent.$options.name !== 'PdtItem') {
        parent = parent.$parent;
      }
      parent.handleSelectWord(this.value, word);
    },
  }
}
</script>